import React, { useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { restoresRef } from "../firebase";
import Footer from "./Footer";
// import { v4 as uuidv4 } from "uuid";
//import { useForm } from "react-hook-form";
import JobDescList from "./JobDescList";
import PrimaryForm from "./PrimaryForm";
import IdentifierBar from "./IdentifierBar";
// import { TimesheetContext } from "../providers/TimesheetProvider";
import { useJobDescriptions } from "../customHooks/useJobDescriptions";
import CloseIcon from "@mui/icons-material/Close";
import useTimesheet from "../customHooks/useTimesheet";
import { CombinedCosts } from "../components/CostCards";
import { useEditMode } from "../customHooks/useEditMode";
import { SlidersContext } from "../providers/SlidersProvider";
import { tooltips } from "../popData";
import FooterBtn from "./FooterBtn";
import { SettingsContext } from "../providers";
// import { dateTimeFormatter } from "../helperFunctions/dateFormatters";

const Restore = () => {
  // const history = useHistory();
  const params = useParams();
  // const { user } = useContext(AuthContext);

  const { inEditMode, toggleEditMode, isMarked, markItem, markedItems } = useEditMode();

  //const { timesheet, setTimesheetId } = useContext(TimesheetContext);
  const timesheet = useTimesheet(restoresRef);
  const jobDescriptions = useJobDescriptions(params.uid, restoresRef);

  const { vat } = useContext(SettingsContext);
  const showVat = timesheet?.vatMode;

  const containerRef = useRef(null);
  const { sliders, setSliderId } = useContext(SlidersContext);

  // const addJobDescription = async function (e) {
  //   return;
  //   const jobDescId = uuidv4();
  //   let currentDate = dateTimeFormatter(new Date(), "d_full_variant");

  //   history.push(`/restore/jobDescription/${jobDescId}`, { timesheetId: params.uid });

  //   await restoresRef.doc(`${params.uid}/jobDescriptions/${jobDescId}`).set({
  //     uid: jobDescId,
  //     jobDetails: "",
  //     rateId: "",
  //     hours: 0,
  //     materials: [],
  //     operatives: [],
  //     customMaterials: [],
  //   });
  // };

  return (
    <div ref={containerRef} className="primaryPage">
      <Footer title={timesheet.refNumber} back={sliders ? false : true}>
        {sliders && (
          <>
            <FooterBtn
              title={tooltips.closeSlider}
              addClass="slider-control"
              cb={() => setSliderId(null)}
            >
              <CloseIcon style={{ fontSize: 28 }} />
            </FooterBtn>
          </>
        )}

        <FooterBtn title={tooltips.vatMode} cb={null}>
          <span
            className="vat-button"
            style={{ color: `${timesheet?.vatMode ? "#24a218" : "#5d5d5d"}` }}
          >
            vat
          </span>
        </FooterBtn>
      </Footer>

      <IdentifierBar title="Restore" back={sliders ? false : true} />
      {/* <p>This is a restore!</p>
      <button onClick={history.goBack}>Back</button> */}

      <PrimaryForm data={timesheet} dbRef={restoresRef} />

      {/* <button onClick={addJobDescription}>Add job description</button> */}

      <JobDescList
        inEditMode={inEditMode}
        toggleEditMode={toggleEditMode}
        isMarked={isMarked}
        markItem={markItem}
        markedItems={markedItems}
        jobDescriptions={jobDescriptions}
        dbRef={restoresRef}
        type="restore"
        timesheetId={params.uid}
      />

      <div className="section">
        <h3 className="heading">Total Costs</h3>
        <CombinedCosts jobDescriptions={jobDescriptions} vat={showVat} />
      </div>
    </div>
  );
};

export default Restore;
